import ReactDOM from "react-dom/client"
import { HashRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout/Layout";
import Home from "./Home/Home";
import About from "./About/About";
import Account from "./Account/Account";
import Vault from "./Vault/Vault"
import More from "./More/More";
import Privacy from "./Privacy/Privacy";
import Search from "./Search/Search";
import Stream from "./Stream/Stream";
import Streams from "./Streams/Streams";
import Terms from "./Terms/Terms";
import Dentists from "./Dentists/Dentists";
import ItemTest from "./ItemTest/ItemTest";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useState } from 'react';

export default function App() {
  const [loggedInEmail, setLoggedInEmail] = useState(localStorage.getItem("useremail"));

  return (
    <GoogleOAuthProvider clientId="713853026947-3tk40sig4uth8pau8suss8cbldi5unpe.apps.googleusercontent.com">
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout loggedInEmail={loggedInEmail} setLoggedInEmail={setLoggedInEmail} />}>
            <Route index element={<Home loggedInEmail={loggedInEmail} />} />
            <Route path="/about" element={<About loggedInEmail={loggedInEmail} />} />
            <Route path="/account" element={<Account loggedInEmail={loggedInEmail} setLoggedInEmail={setLoggedInEmail} />} />
            <Route path="/vault" element={<Vault loggedInEmail={loggedInEmail} />} />
            <Route path="/more" element={<More loggedInEmail={loggedInEmail} />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/s/:guid" element={<Stream loggedInEmail={loggedInEmail} />} />
            <Route path="/search" element={<Search loggedInEmail={loggedInEmail}/>} />
            <Route path="/streams" element={<Streams loggedInEmail={loggedInEmail} />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/dentists" element={<Dentists />} />
            <Route path="/itemtest" element={<ItemTest />} />
          </Route>
        </Routes>
      </HashRouter>
    </GoogleOAuthProvider>
  );
}